import Vue from 'vue';
import { IonicVueRouter } from '@ionic/vue';
import Home from './views/Home.vue';
import Login from './views/Unauthorized/Login.vue';
import SignUp from './views/Unauthorized/SignUp.vue';
import ForgotPassword from './views/Unauthorized/ForgotPassword.vue';
import Edit from './views/Edit';
import Profile from './views/Profile';
import EditItem from './views/EditItem';
import Add from './views/Add';
import Settings from './views/Settings/Settings';
import CaregiverInvites from './views/Settings/Caregiver/Invites';
import Details from './views/Details';
import Kid from './views/Kid';

import store from './store/store'

import * as firebase from 'firebase/app';

Vue.use(IonicVueRouter);

const router = new IonicVueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
            path: '*',
            component: Login
        },
        {
            path: '/',
            component: Login
        },
        {
            path: '/',
            name: 'Login',
            component: Login
        },
        {
            path: '/register',
            name: 'register',
            component: SignUp
        },
        {
            path: '/reset-password',
            component: ForgotPassword
        },
        {
            path: '/dashboard',
            name: 'home',
            component: Home,
            meta: {
                requiresAuth: true
            }
        },
        {
          path: '/kind',
          name: 'kind',
          component: Kid,
          meta: {
              requiresAuth: true
          }
        },
        {
            path: '/edit',
            name: 'edit',
            component: Edit,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/edit/:id',
            name: 'editItem',
            component: EditItem,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/add',
            name: 'addItem',
            component: Add,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/profile',
            name: 'profile',
            component: Profile,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/settings',
            name: 'settings',
            component: Settings,
            meta: {
                requiresAuth: true
            },
        },
        {
            path: '/caregiver/invites',
            name: 'caregiver',
            component: CaregiverInvites,
            meta: {
                requiresAuth: true
            },
        },
        {
            path: '/details',
            name: 'details',
            component: Details,
            meta: {
                requiresAuth: true
            },
        }
    ]
});
router.beforeEach((to, from, next) => {
    const currentUser = firebase.auth().currentUser;
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    if (requiresAuth && !currentUser) {
        next('login');
    } else if (!requiresAuth && currentUser) {
        next('dashboard');
    } else {
        next();
    }
});

export default router;
